export default __webpack_public_path__ + "static/media/Ballroll_00208.a2a9552b.png";